var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class CreateFileResult {
  constructor(_data) {
    /**
     */
    __publicField(this, "SasUri");
    /**
     */
    __publicField(this, "SourceFileId");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof CreateFileResult
     */
    __publicField(this, "$type", "V1.Cesop.Periods.CreateFileResult");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.SasUri = _data["SasUri"];
      this.SourceFileId = _data["SourceFileId"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["SasUri"] = this.SasUri;
    _data["SourceFileId"] = this.SourceFileId;
    return _data;
  }
}
